<div class="relative flex flex-col w-full h-full">

    <!-- Dismiss button -->
    <ng-container *ngIf="data?.dismissible">
        <div class="absolute top-0 right-0 pt-4 pr-4">
            <button
                mat-icon-button
                [matDialogClose]="undefined">
                <mat-icon
                    class="text-secondary cursor-pointer"
                    [svgIcon]="'heroicons_outline:x'"></mat-icon>
            </button>
        </div>
    </ng-container>

    <!-- Content -->
    <div class="flex flex-col sm:flex-row flex-auto items-center sm:items-start p-8 pb-6 sm:pb-8">

        <!-- Icon -->
        <ng-container *ngIf="data?.icon?.show">
            <div
                class="flex flex-0 items-center justify-center w-10 h-10 sm:mr-4 rounded-full"
                [ngClass]="getIconClass(data?.icon?.color)">
                <mat-icon
                    class="text-current"
                    [svgIcon]="data?.icon?.name"></mat-icon>
            </div>
        </ng-container>

        <ng-container *ngIf="data?.title || data?.message">
            <div class="flex flex-col items-center sm:items-start mt-4 sm:mt-0 sm:pr-8 space-y-1 text-center sm:text-left">

                <!-- Title -->
                <ng-container *ngIf="data?.title">
                    <div
                        class="text-xl leading-6 font-medium"
                        [innerHTML]="data?.title"></div>
                </ng-container>

                <!-- Message -->
                <ng-container *ngIf="data?.message">
                    <div
                        class="text-secondary"
                        [innerHTML]="data?.message"></div>
                </ng-container>
                <!-- Note -->
                <ng-container *ngIf="data?.note">
                    <div [ngClass]="getNoteClass" class="text-base" [innerHTML]="data?.note">
                    </div>
                </ng-container>
            </div>
        </ng-container>

    </div>

    <!-- Actions -->
    <ng-container *ngIf="data?.actions?.confirm?.show || data?.actions?.cancel?.show">
        <div class="flex items-center justify-center sm:justify-end px-6 py-4 space-x-3 bg-gray-50 dark:bg-black dark:bg-opacity-10">

            <!-- Cancel -->
            <ng-container *ngIf="data?.actions?.cancel?.show">
                <button
                    mat-stroked-button
                    [matDialogClose]="false" class="px-6 flex items-center py-2 border shadow-sm text-gray-600 bg-white text-base font-medium rounded-md btn-small">
                    {{getCancelDisplayKey}}
                </button>
            </ng-container>

            <!-- Confirm -->
            <ng-container *ngIf="data?.actions?.confirm?.show">
                <button
                    [matDialogClose]="true"
                    [ngClass]="getConfirmButtonClass" class="px-6 flex items-center py-2 border shadow-sm text-white text-base font-medium rounded-md btn-small">
                    {{getConfirmDisplayKey}}
                </button>
            </ng-container>

        </div>
    </ng-container>

</div>
